import { Routes } from '@angular/router';
import { EditStructureComponent } from './edit-structure/edit-structure.component';
import { ListeStructuresComponent } from './liste-structures/liste-structures.component';

export const STRUCTURES_ROUTES_DATA = {
    role: 'ORGANISME',
    domaines: ['ANPP']
};

export const STRUCTURES_ROUTES: Routes = [
    { path: '', component: ListeStructuresComponent, data: { roles: ['ORGANISME'] } },
    { path: 'edit/:id', component: EditStructureComponent, data: { roles: ['ORGANISME'] } },
    { path: 'new', component: EditStructureComponent, data: { roles: ['ORGANISME'] } }
];
